export default function generateGuid(): string {
    // The pattern contains 32 hex characters with a fixed '4' and appropriate variant.
    const pattern = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx';
    return pattern.replace(/[xy]/g, (char) => {
        const random = Math.random() * 16 | 0;
        // For 'x', use random; for 'y', ensure bits 8, 9, A, or B.
        const value = char === 'x' ? random : (random & 0x3 | 0x8);
        return value.toString(16);
    });
}
  